import { createSlice } from "@reduxjs/toolkit";

const contactSlice = createSlice({
    name: 'contact',
    initialState: {
        contactType: '',
        contactName: '',
        contactEmail: '',
        contactNumber: '',
        contactMessage: '',
        loading: false,
        error: null,
        success: false,
    },
    reducers: {
        setContactType: (state, action) => {
            state.contactType = action.payload
        },
        setContactName: (state, action) => {
            state.contactName = action.payload
        },
        setContactEmail: (state, action) => {
            state.contactEmail = action.payload
        },
        setContactNumber: (state, action) => {
            state.contactNumber = action.payload
        },
        setContactMessage: (state, action) => {
            state.contactMessage = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setSuccess: (state, action) => {
            state.success = action.payload
        },
    }
})

export const {
    setContactType,
    setContactName,
    setContactEmail,
    setContactNumber,
    setContactMessage,
    setLoading,
    setError,
    setSuccess,
} = contactSlice.actions

export default contactSlice.reducer